import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

// Indicativos más frecuentes (Colombia primero). El número final se arma en
// formato E.164: +<indicativo><número>, válido para iniciar un chat de WhatsApp.
export const PHONE_COUNTRIES = [
  { code: '57', label: '🇨🇴 +57' },
  { code: '52', label: '🇲🇽 +52' },
  { code: '51', label: '🇵🇪 +51' },
  { code: '593', label: '🇪🇨 +593' },
  { code: '56', label: '🇨🇱 +56' },
  { code: '54', label: '🇦🇷 +54' },
  { code: '507', label: '🇵🇦 +507' },
  { code: '506', label: '🇨🇷 +506' },
  { code: '502', label: '🇬🇹 +502' },
  { code: '503', label: '🇸🇻 +503' },
  { code: '504', label: '🇭🇳 +504' },
  { code: '505', label: '🇳🇮 +505' },
  { code: '591', label: '🇧🇴 +591' },
  { code: '595', label: '🇵🇾 +595' },
  { code: '598', label: '🇺🇾 +598' },
  { code: '58', label: '🇻🇪 +58' },
  { code: '1', label: '🇺🇸 +1' },
  { code: '34', label: '🇪🇸 +34' },
];

const E164_RE = /^\+[1-9]\d{7,14}$/;

/** Arma el número E.164 (o null si no es válido) a partir del indicativo y lo digitado. */
export function buildE164(countryCode: string, local: string): string | null {
  let digits = (local || '').replace(/\D/g, '');
  // Si pegaron el número con el indicativo incluido, no duplicarlo.
  if (digits.startsWith(countryCode) && digits.length > countryCode.length + 7) {
    digits = digits.slice(countryCode.length);
  }
  if (digits.length < 7 || digits.length > 12) return null;
  const full = `+${countryCode}${digits}`;
  return E164_RE.test(full) ? full : null;
}

interface Props {
  id?: string;
  countryCode: string;
  onCountryCodeChange: (code: string) => void;
  value: string;
  onChange: (value: string) => void;
  invalid?: boolean;
}

export function PhoneCountryInput({ id, countryCode, onCountryCodeChange, value, onChange, invalid }: Props) {
  return (
    <div className="flex gap-2">
      <Select value={countryCode} onValueChange={onCountryCodeChange}>
        <SelectTrigger className="w-[110px] shrink-0" aria-label="Indicativo del país">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {PHONE_COUNTRIES.map(c => (
            <SelectItem key={c.code} value={c.code}>{c.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        id={id}
        type="tel"
        inputMode="tel"
        autoComplete="tel-national"
        placeholder="300 123 4567"
        value={value}
        onChange={e => onChange(e.target.value)}
        aria-invalid={invalid || undefined}
        className={invalid ? 'border-destructive focus-visible:ring-destructive' : undefined}
      />
    </div>
  );
}

export default PhoneCountryInput;
